<ng-container *ngIf="appComponentData$ | async as appComponentData; else loading">
  <main>
    <router-outlet />
  </main>
</ng-container>
<ng-template #loading>
  <app-loader></app-loader>
</ng-template>
